/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useWorkFlow, LOCK_BUTTON, UPDATE_CAPTCHA } from "../../../contexts/workflow";
import { _translate, _Notifications } from "../../../../services/core";
import { _Captcha as Captcha } from "../../../core/common";
var CustomEnds = function CustomEnds() {
  var _community$dataPrivat, _community$dataPrivat2, _community$dataPrivat3, _community$dataPrivat4;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    actions = _useWorkFlow.actions,
    dispatcher = _useWorkFlow.dispatcher;
  var currentQuestion = collector.currentQuestion,
    captcha = collector.captcha;
  var community = collector.diag ? collector.diag.community : {
    polygon: null,
    polygonColor: null
  };
  var _currentQuestion$publ = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.publicParameters,
    labelEnd = _currentQuestion$publ.labelEnd;
  var handleCaptchaSuccess = function handleCaptchaSuccess(token, key) {
    dispatcher({
      type: UPDATE_CAPTCHA,
      value: {
        token: token,
        key: key
      }
    });
  };
  var handleCaptchaFailure = function handleCaptchaFailure() {
    _Notifications.warning(_translate('collectorapp_captcha_title'), _translate('collectorapp_captcha_failed'));
    dispatcher({
      type: UPDATE_CAPTCHA,
      value: null
    });
  };
  useEffect(function () {
    dispatcher({
      type: LOCK_BUTTON,
      value: true
    });
  }, []);
  return /*#__PURE__*/React.createElement(Row, {
    className: "w-100"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "align-self-center col-12 d-flex align-items-center justify-content-center w-100 flex-column "
  }, /*#__PURE__*/React.createElement(Captcha, {
    number: "6",
    onSuccess: handleCaptchaSuccess,
    onFailure: handleCaptchaFailure
  }), /*#__PURE__*/React.createElement("button", {
    className: "collectorButton btn-custom-end",
    onClick: function onClick() {
      return actions.save(false);
    },
    disabled: !captcha,
    style: {
      backgroundColor: (_community$dataPrivat = (_community$dataPrivat2 = community.dataPrivate.secondaryColor) === null || _community$dataPrivat2 === void 0 ? void 0 : _community$dataPrivat2.value) !== null && _community$dataPrivat !== void 0 ? _community$dataPrivat : '#d73754',
      color: (_community$dataPrivat3 = (_community$dataPrivat4 = community.dataPrivate.secondaryColor) === null || _community$dataPrivat4 === void 0 ? void 0 : _community$dataPrivat4.value) !== null && _community$dataPrivat3 !== void 0 ? _community$dataPrivat3 : '#d73754'
    }
  }, _translate(labelEnd !== null && labelEnd !== void 0 ? labelEnd : 'collectorapp_button_end_custom_1'))));
};
export default CustomEnds;